export default __webpack_public_path__ + "static/media/tv.8ba922d8.png";